import { create } from 'zustand';

const INITIAL_STATE_FORM: CreateAccount.Form = {
  email: '',
  document: '',
  personalInfo: null,
  password: null,
};

type State = {
  form: CreateAccount.Form | null;
  setEmail: (email: string) => void;
  setDocument: (document: string) => void;
  setPersonalInfo: (personalInfo: CreateAccount.PersonalInfo) => void;
  setPassword: (password: string) => void;
};

const updateForm = (
  state: State,
  field: keyof CreateAccount.Form,
  value: any
): State => {
  return {
    ...state,
    form: { ...(state.form || { ...INITIAL_STATE_FORM }), [field]: value },
  };
};

const useCreateAccountForm = create<State>((set) => ({
  form: { ...INITIAL_STATE_FORM },
  setEmail: (email) => set((state) => updateForm(state, 'email', email)),
  setDocument: (document) =>
    set((state) => updateForm(state, 'document', document)),
  setPersonalInfo: (personalInfo) =>
    set((state) => updateForm(state, 'personalInfo', personalInfo)),
  setPassword: (password) =>
    set((state) => updateForm(state, 'password', password)),
}));

export default useCreateAccountForm;
